import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { InviteForm } from "@/components/candidates/invite-form";
import { useDict } from "@/lib/i18n/context";

export function NewCandidatePage() {
  const t = useDict();
  const [searchParams] = useSearchParams();
  const job = searchParams.get("job") || undefined;
  const defaultEmail = searchParams.get("email") || undefined;
  const defaultName = searchParams.get("name") || undefined;
  const [jobs, setJobs] = useState<{ id: string; title: string }[] | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    setLoading(true);
    fetch("/api/jobs/options", { credentials: "include" })
      .then(async (res) => {
        if (!res.ok) throw new Error("Failed to load");
        return res.json() as Promise<{ jobs: { id: string; title: string }[] }>;
      })
      .then((data) => {
        if (active) setJobs(data.jobs);
      })
      .catch(() => {
        if (active) setError("Failed to load");
      })
      .finally(() => {
        if (active) setLoading(false);
      });
    return () => {
      active = false;
    };
  }, []);

  if (loading) {
    return (
      <div className="flex min-h-[40vh] items-center justify-center text-muted">
        Loading…
      </div>
    );
  }
  if (error || !jobs) {
    return (
      <div className="flex min-h-[40vh] items-center justify-center text-muted">
        {error || "Failed to load"}
      </div>
    );
  }

  return (
    <div className="mx-auto max-w-2xl space-y-6">
      <Link
        to="/candidates"
        className="inline-flex items-center gap-1 text-sm text-muted hover:text-foreground"
      >
        <ArrowLeft className="h-4 w-4 rtl:rotate-180" /> {t.common.back}
      </Link>
      <div>
        <h1 className="text-2xl font-bold">{t.candidates.newTitle}</h1>
        <p className="text-muted">{t.candidates.newSubtitle}</p>
      </div>
      <InviteForm
        jobs={jobs}
        defaultJobId={job}
        defaultEmail={defaultEmail}
        defaultName={defaultName}
      />
    </div>
  );
}
